<template lang="pug">
  section.section-4
    .block-wrap
      .slider
        i.mdi.mdi-format-quote-close.quote
        .swap-container(@mousedown="down($event)" @mouseup="up($event)" @touchstart="touchDown($event)" @touchend="touchUp" @touchmove="touchMove($event)")
          .slide(v-for="(item, index) in feedbacks" :key="item.id" v-if="index === currentDot")
            p "{{ item.comment }}"
            p.author - {{ item.author }}
        .dots
          .dot(v-for="(item, index) in feedbacks" :key="item.id" :class="{'active': currentDot === index}" @click="changePhrase(index)")
</template>

<script>
import { gettext } from '@/services/TranslateHandler'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'slider',
  data () {
    return {
      feedbacks: [],
      currentPhrase: '',
      currentDot: 0,
      mouse: {
        x: 0,
        y: 0
      },
      touch: {
        start: false,
        y: 0,
        x: 0,
        changedX: 0,
        changedY: 0
      }
    }
  },
  methods: {
    ...mapActions(['receiveFeedbacks']),
    gettext: gettext,
    changePhrase (i) {
      this.currentPhrase = this.feedbacks[i]
      this.currentDot = i
    },
    touchDown (e) {
      if (e.touches.length !== 1 || this.touch.start) {
        return
      }
      this.touch.start = true
      this.touch.y = e.touches[0].clientY
      this.touch.x = e.touches[0].clientX
    },
    touchUp () {
      if (this.touch.start) return
      var deltaX = Math.abs(this.touch.x - this.touch.changedX)
      var deltaY = Math.abs(this.touch.y - this.touch.changedY)
      if (deltaY === 0 && deltaX === 0) return
      if (deltaX > deltaY) {
        if (this.touch.x > this.touch.changedX) {
          this.nexSlide()
        } else {
          this.prevSlide()
        }
      }
      this.touch.start = false
    },
    touchMove (e) {
      if (!this.touch.start || e.touches.length !== 1) {
        return
      }
      this.touch.start = false
      this.touch.changedX = e.touches[0].clientX
      this.touch.changedY = e.touches[0].clientY
    },
    down (e) {
      this.mouse.x = e.clientX
      this.mouse.y = e.clientY
    },
    up (e) {
      var deltaX = Math.abs(this.mouse.x - e.clientX)
      var deltaY = Math.abs(this.mouse.y - e.clientY)
      if (deltaX === 0 && deltaY === 0) return
      if (this.mouse.x > e.clientX) {
        this.nexSlide()
      } else {
        this.prevSlide()
      }
    },
    nexSlide () {
      if (this.currentDot < this.feedbacks.length - 1) {
        this.currentDot = this.currentDot + 1
        this.currentPhrase = this.feedbacks[this.currentDot]
      } else {
        this.currentDot = 0
        this.currentPhrase = this.feedbacks[this.currentDot]
      }
    },
    prevSlide () {
      if (this.currentDot > 0) {
        this.currentDot = this.currentDot - 1
        this.currentPhrase = this.feedbacks[this.currentDot]
      } else {
        this.currentDot = this.feedbacks.length - 1
        this.currentPhrase = this.feedbacks[this.currentDot]
      }
    },
    getFeedbacks () {
      this.receiveFeedbacks({lang: this.getLanguage, pageNum: 1, pageSize: 10}).then(res => {
        this.feedbacks = res
        this.currentPhrase = this.feedbacks[0]
      })
    }
  },
  computed: {
    ...mapGetters(['getLanguage'])
  },
  watch: {
    getLanguage: function () {
      this.getFeedbacks()
    }
  },
  created () {
    this.getFeedbacks()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/agricultural-trainee/parts/slider/index.vue